"use strict";

module.exports = [
  "get", "put", "post", "delete", "options", "head", "patch"
];
